import React from "react";
import { BattleInfoProps } from "./types";

interface IStatsBar {
  label: string;
  type: string;
  key: "hp" | "mp";
}

const statsBars: IStatsBar[] = [
  { label: "HP", type: "error", key: "hp" },
  { label: "MP", type: "primary", key: "mp" }
];

const StatsInfo = ({ stats }: Pick<BattleInfoProps, "stats">) => (
  <>
    {statsBars.map(({ label, type, key }) => (
      <div key={key} className="battle-info-stats">
        <span className={`nes-text is-${type}`}>{label}</span>
        <progress
          className={`nes-progress is-${type}`}
          value={stats[key].value}
          max={stats[key].max}
        />
      </div>
    ))}
  </>
);

const statusInfo = {
  poison: { backgroundColor: "palegreen" },
  sleep: { backgroundColor: "lightgrey" },
  blind: { backgroundColor: "#9269e2" }, // purple
  shell: { backgroundColor: "pink" },
  protect: { backgroundColor: "lightblue" }
};
const StatusInfo = ({ statuses = [] }: Pick<BattleInfoProps, "statuses">) => (
  <div className="battle-info-statuses">
    {statuses.map(status => (
      <div
        key={status.key}
        className="battle-info-status"
        style={{
          backgroundColor: statusInfo[status.key].backgroundColor
        }}
      />
    ))}
  </div>
);

export default function BattleInfo({ stats, statuses }: BattleInfoProps) {
  return (
    <div className="battle-info">
      <StatsInfo stats={stats} />
      <StatusInfo statuses={statuses} />
    </div>
  );
}
